/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DictionaryDto
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **Any authenticated role**
 */
export const getDictionaryByType = (
    userId: string,
    type: 'PRODUCT_TYPE' | 'AID_MODEL_STATUS' | 'AID_MODEL_DATASET_STATUS' | 'ENROLLMENT_TYPE' | 'AID_SPECIAL_FUND_TYPE' | 'AID_SPECIAL_FUND_SOURCE' | 'AWARDING_TYPE' | 'COA_CATEGORY' | 'REGIME_AWARD_TYPE' | 'REGIME_CALCULATED_BY' | 'REGIME_POPULATION',
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DictionaryDto[]>(
      {url: `/api/${userId}/dictionary/${type}`, method: 'GET', signal
    },
      options);
    }




export const getGetDictionaryByTypeQueryKey = (userId: string,
    type: 'PRODUCT_TYPE' | 'AID_MODEL_STATUS' | 'AID_MODEL_DATASET_STATUS' | 'ENROLLMENT_TYPE' | 'AID_SPECIAL_FUND_TYPE' | 'AID_SPECIAL_FUND_SOURCE' | 'AWARDING_TYPE' | 'COA_CATEGORY' | 'REGIME_AWARD_TYPE' | 'REGIME_CALCULATED_BY' | 'REGIME_POPULATION',) => {
    return [
    `/api/${userId}/dictionary/${type}`
    ] as const;
    }


export const getGetDictionaryByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDictionaryByType>>, TError = ErrorType<unknown>>(userId: string,
    type: 'PRODUCT_TYPE' | 'AID_MODEL_STATUS' | 'AID_MODEL_DATASET_STATUS' | 'ENROLLMENT_TYPE' | 'AID_SPECIAL_FUND_TYPE' | 'AID_SPECIAL_FUND_SOURCE' | 'AWARDING_TYPE' | 'COA_CATEGORY' | 'REGIME_AWARD_TYPE' | 'REGIME_CALCULATED_BY' | 'REGIME_POPULATION', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDictionaryByType>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDictionaryByTypeQueryKey(userId,type);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDictionaryByType>>> = ({ signal }) => getDictionaryByType(userId,type, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && type), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDictionaryByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDictionaryByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDictionaryByType>>>
export type GetDictionaryByTypeQueryError = ErrorType<unknown>


export function useGetDictionaryByType<TData = Awaited<ReturnType<typeof getDictionaryByType>>, TError = ErrorType<unknown>>(
 userId: string,
    type: 'PRODUCT_TYPE' | 'AID_MODEL_STATUS' | 'AID_MODEL_DATASET_STATUS' | 'ENROLLMENT_TYPE' | 'AID_SPECIAL_FUND_TYPE' | 'AID_SPECIAL_FUND_SOURCE' | 'AWARDING_TYPE' | 'COA_CATEGORY' | 'REGIME_AWARD_TYPE' | 'REGIME_CALCULATED_BY' | 'REGIME_POPULATION', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDictionaryByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDictionaryByType>>,
          TError,
          Awaited<ReturnType<typeof getDictionaryByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDictionaryByType<TData = Awaited<ReturnType<typeof getDictionaryByType>>, TError = ErrorType<unknown>>(
 userId: string,
    type: 'PRODUCT_TYPE' | 'AID_MODEL_STATUS' | 'AID_MODEL_DATASET_STATUS' | 'ENROLLMENT_TYPE' | 'AID_SPECIAL_FUND_TYPE' | 'AID_SPECIAL_FUND_SOURCE' | 'AWARDING_TYPE' | 'COA_CATEGORY' | 'REGIME_AWARD_TYPE' | 'REGIME_CALCULATED_BY' | 'REGIME_POPULATION', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDictionaryByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDictionaryByType>>,
          TError,
          Awaited<ReturnType<typeof getDictionaryByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDictionaryByType<TData = Awaited<ReturnType<typeof getDictionaryByType>>, TError = ErrorType<unknown>>(
 userId: string,
    type: 'PRODUCT_TYPE' | 'AID_MODEL_STATUS' | 'AID_MODEL_DATASET_STATUS' | 'ENROLLMENT_TYPE' | 'AID_SPECIAL_FUND_TYPE' | 'AID_SPECIAL_FUND_SOURCE' | 'AWARDING_TYPE' | 'COA_CATEGORY' | 'REGIME_AWARD_TYPE' | 'REGIME_CALCULATED_BY' | 'REGIME_POPULATION', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDictionaryByType>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDictionaryByType<TData = Awaited<ReturnType<typeof getDictionaryByType>>, TError = ErrorType<unknown>>(
 userId: string,
    type: 'PRODUCT_TYPE' | 'AID_MODEL_STATUS' | 'AID_MODEL_DATASET_STATUS' | 'ENROLLMENT_TYPE' | 'AID_SPECIAL_FUND_TYPE' | 'AID_SPECIAL_FUND_SOURCE' | 'AWARDING_TYPE' | 'COA_CATEGORY' | 'REGIME_AWARD_TYPE' | 'REGIME_CALCULATED_BY' | 'REGIME_POPULATION', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDictionaryByType>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDictionaryByTypeQueryOptions(userId,type,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






